module.exports = __webpack_public_path__ + "static/img_4-b5db5f2e07852e5f5a89cc92e6d63382.png";